module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    directives: [{
      name: "permission",
      rawName: "v-permission.if",
      value: ([_vm.USER_ROLES.ADMIN, _vm.USER_ROLES.SUPER_ADMIN, _vm.USER_ROLES.GA_HEAD, _vm.USER_ROLES.JOURNEY_MANAGER]),
      expression: "[USER_ROLES.ADMIN,USER_ROLES.SUPER_ADMIN,USER_ROLES.GA_HEAD,USER_ROLES.JOURNEY_MANAGER]",
      modifiers: {
        "if": true
      }
    }]
  }, [(_vm.loading) ? _c('div', {
    staticClass: "content content-centered"
  }, [_c('pulse-loader')], 1) : _vm._e(), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.loading),
      expression: "!loading"
    }],
    staticClass: "content"
  }, [_c('div', {
    staticClass: "box"
  }, [_c('div', {
    staticClass: "box-body"
  }, [_c('div', {
    staticClass: "row"
  }, [(_vm.flash) ? _c('div', {
    staticClass: "flash-message col-md-4 col-md-offset-4 text-center"
  }, [_c('div', {
    staticClass: "alert",
    class: 'alert-' + _vm.flashType
  }, [_vm._v(_vm._s(_vm.flashMessage))])]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "row",
    attrs: {
      "id": "details"
    }
  }, [_c('vue-form', {
    staticClass: "row",
    attrs: {
      "state": _vm.formstate
    },
    on: {
      "submit": function($event) {
        $event.preventDefault();
        return _vm.onSubmit($event)
      }
    }
  }, [_c('div', {
    staticClass: "col-sm-12"
  }, [_c('div', {
    staticClass: "col-sm-6"
  }, [_c('validate', {
    staticClass: "form-group required-field",
    class: _vm.fieldClassName(_vm.formstate.driverName),
    attrs: {
      "auto-label": ""
    }
  }, [_c('label', [_vm._v("Name")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.lazy",
      value: (_vm.driver.driverName),
      expression: "driver.driverName",
      modifiers: {
        "lazy": true
      }
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "minlength": "3",
      "maxlength": "20",
      "name": "driverName",
      "required": "",
      "placeholder": "Name"
    },
    domProps: {
      "value": (_vm.driver.driverName)
    },
    on: {
      "change": function($event) {
        _vm.$set(_vm.driver, "driverName", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('field-messages', {
    staticClass: "form-control-feedback",
    attrs: {
      "name": "driverName",
      "show": "$touched || $submitted"
    }
  }, [_c('div', {
    attrs: {
      "slot": "required"
    },
    slot: "required"
  }, [_vm._v("Driver name is a required field")]), _vm._v(" "), _c('div', {
    attrs: {
      "slot": "pattern"
    },
    slot: "pattern"
  }, [_vm._v("Driver Name is invalid")]), _vm._v(" "), _c('div', {
    attrs: {
      "slot": "minlength"
    },
    slot: "minlength"
  }, [_vm._v("Driver name should be more than 3 characters")]), _vm._v(" "), _c('div', {
    attrs: {
      "slot": "maxlength"
    },
    slot: "maxlength"
  }, [_vm._v("Driver name should be less than 20 characters")])])], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "col-sm-3"
  }, [_c('validate', {
    staticClass: "form-group required-field",
    class: _vm.fieldClassName(_vm.formstate.mobileNumber),
    attrs: {
      "auto-label": ""
    }
  }, [_c('label', [_vm._v("Mobile Number")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.lazy",
      value: (_vm.driver.mobileNumber),
      expression: "driver.mobileNumber",
      modifiers: {
        "lazy": true
      }
    }],
    staticClass: "form-control",
    attrs: {
      "type": "number",
      "min": "1000000000",
      "name": "mobileNumber",
      "required": "",
      "placeholder": "Mobile number",
      "pattern": "[78965][0-9]{9}"
    },
    domProps: {
      "value": (_vm.driver.mobileNumber)
    },
    on: {
      "change": function($event) {
        _vm.$set(_vm.driver, "mobileNumber", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('field-messages', {
    staticClass: "form-control-feedback",
    attrs: {
      "name": "mobileNumber",
      "show": "$touched || $submitted"
    }
  }, [_c('div', {
    attrs: {
      "slot": "required"
    },
    slot: "required"
  }, [_vm._v("Mobile number is a required field")]), _vm._v(" "), _c('div', {
    attrs: {
      "slot": "pattern"
    },
    slot: "pattern"
  }, [_vm._v("Mobile number is invalid")])])], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "col-sm-3"
  }, [_c('validate', {
    staticClass: "form-group required-field",
    class: _vm.fieldClassName(_vm.formstate.status),
    attrs: {
      "auto-label": ""
    }
  }, [_c('label', [_vm._v("Status")]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.driver.status),
      expression: "driver.status"
    }],
    staticClass: "form-control",
    attrs: {
      "required": "",
      "name": "status"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.driver, "status", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, [_c('option', {
    attrs: {
      "value": "",
      "disabled": ""
    }
  }, [_vm._v("Select Status")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "active"
    }
  }, [_vm._v("Active")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "inactive"
    }
  }, [_vm._v("Inactive")])]), _vm._v(" "), _c('field-messages', {
    staticClass: "form-control-feedback",
    attrs: {
      "name": "status",
      "show": "$touched || $submitted"
    }
  }, [_c('div', {
    attrs: {
      "slot": "required"
    },
    slot: "required"
  }, [_vm._v("Status is a required field")]), _vm._v(" "), _c('div', {
    attrs: {
      "slot": "pattern"
    },
    slot: "pattern"
  }, [_vm._v("Status is invalid")])])], 1)], 1)]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-12"
  }, [_c('div', {
    staticClass: "col-sm-3"
  }, [_c('validate', {
    staticClass: "form-group required-field",
    class: _vm.fieldClassName(_vm.formstate.dateOfBirth),
    attrs: {
      "auto-label": ""
    }
  }, [_c('label', [_vm._v("Date of Birth")]), _vm._v(" "), _c('date-picker', {
    attrs: {
      "max": this.minDate,
      "id": "dateOfBirth",
      "required": "",
      "lang": "en",
      "name": "dateOfBirth",
      "input-class": "form-control",
      "width": "100%",
      "use-utc": "true",
      "format": "DD-MM-YYYY",
      "disabledDates": _vm.disabledDates
    },
    on: {
      "change": _vm.getEligibleDate
    },
    model: {
      value: (_vm.driver.dateOfBirth),
      callback: function($$v) {
        _vm.$set(_vm.driver, "dateOfBirth", $$v)
      },
      expression: "driver.dateOfBirth"
    }
  }), _vm._v(" "), _c('field-messages', {
    staticClass: "form-control-feedback",
    attrs: {
      "name": "dateOfBirth",
      "show": "$touched || $submitted"
    }
  }, [_c('div', {
    attrs: {
      "slot": "required"
    },
    slot: "required"
  }, [_vm._v("Date of Birth is a required field")]), _vm._v(" "), _c('div', {
    attrs: {
      "slot": "max"
    },
    slot: "max"
  }, [_vm._v("Minimum age is 18 years")])])], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "col-sm-3"
  }, [_c('validate', {
    staticClass: "form-group required-field",
    class: _vm.fieldClassName(_vm.formstate.driverPin),
    attrs: {
      "auto-label": ""
    }
  }, [_c('label', [_vm._v("Driver Pin")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.lazy",
      value: (_vm.driver.driverPin),
      expression: "driver.driverPin",
      modifiers: {
        "lazy": true
      }
    }],
    staticClass: "form-control",
    attrs: {
      "type": "number",
      "min": "1000",
      "max": "9999",
      "name": "driverPin",
      "required": "",
      "placeholder": "Driver Pin"
    },
    domProps: {
      "value": (_vm.driver.driverPin)
    },
    on: {
      "change": function($event) {
        _vm.$set(_vm.driver, "driverPin", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('field-messages', {
    staticClass: "form-control-feedback",
    attrs: {
      "name": "driverPin",
      "show": "$touched || $submitted"
    }
  }, [_c('div', {
    attrs: {
      "slot": "required"
    },
    slot: "required"
  }, [_vm._v("Driver pin is a required field")]), _vm._v(" "), _c('div', {
    attrs: {
      "slot": "pattern"
    },
    slot: "pattern"
  }, [_vm._v("Driver pin is invalid")]), _vm._v(" "), _c('div', {
    attrs: {
      "slot": "min"
    },
    slot: "min"
  }, [_vm._v("Driver pin is minimum 4 digit")]), _vm._v(" "), _c('div', {
    attrs: {
      "slot": "max"
    },
    slot: "max"
  }, [_vm._v("Driver pin is Maximum 4 digit")])])], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "col-sm-3"
  }, [_c('validate', {
    staticClass: "form-group required-field",
    class: _vm.fieldClassName(_vm.formstate.region),
    attrs: {
      "auto-label": ""
    }
  }, [_c('label', [_vm._v("Geographical Area")]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.driver.region),
      expression: "driver.region"
    }],
    staticClass: "form-control",
    attrs: {
      "required": "",
      "name": "region"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.driver, "region", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, [_c('option', {
    attrs: {
      "value": "",
      "disabled": ""
    }
  }, [_vm._v("Select G.A")]), _vm._v(" "), _vm._l((_vm.region_list), function(item, index) {
    return _c('option', {
      key: index,
      domProps: {
        "value": item.key
      }
    }, [_vm._v("\n                                            " + _vm._s(item.value) + "\n                                        ")])
  })], 2), _vm._v(" "), _c('field-messages', {
    staticClass: "form-control-feedback",
    attrs: {
      "name": "region",
      "show": "$touched || $submitted"
    }
  }, [_c('div', {
    attrs: {
      "slot": "required"
    },
    slot: "required"
  }, [_vm._v("Geographical Area is a required field")])])], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "col-sm-3"
  }, [_c('validate', {
    staticClass: "form-group required-field",
    class: _vm.fieldClassName(_vm.formstate.vehicleId),
    attrs: {
      "auto-label": ""
    }
  }, [_c('label', [_vm._v("Vehicle")]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.driver.vehicleId),
      expression: "driver.vehicleId"
    }],
    staticClass: "form-control",
    attrs: {
      "required": "",
      "name": "vehicleId"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.driver, "vehicleId", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, [_c('option', {
    attrs: {
      "value": "",
      "disabled": ""
    }
  }, [_vm._v("Select Vehicle")]), _vm._v(" "), _vm._l((_vm.vehicle_no), function(item, index) {
    return _c('option', {
      key: index,
      domProps: {
        "value": item.key
      }
    }, [_vm._v("\n                                            " + _vm._s(item.value) + "\n                                        ")])
  })], 2), _vm._v(" "), _c('field-messages', {
    staticClass: "form-control-feedback",
    attrs: {
      "name": "vehicleId",
      "show": "$touched || $submitted"
    }
  }, [_c('div', {
    attrs: {
      "slot": "required"
    },
    slot: "required"
  }, [_vm._v("Vehicle is a required field")])])], 1)], 1)]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-12"
  }, [_c('div', {
    staticClass: "col-sm-3"
  }, [_c('validate', {
    staticClass: "form-group required-field",
    class: _vm.fieldClassName(_vm.formstate.lisenceNumber),
    attrs: {
      "auto-label": ""
    }
  }, [_c('label', [_vm._v("License No")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.lazy",
      value: (_vm.driver.lisenceNumber),
      expression: "driver.lisenceNumber",
      modifiers: {
        "lazy": true
      }
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "maxlength": "20",
      "minlength": "10",
      "name": "lisenceNumber",
      "required": "",
      "placeholder": "License No"
    },
    domProps: {
      "value": (_vm.driver.lisenceNumber)
    },
    on: {
      "keydown": _vm.validateRegistration,
      "change": function($event) {
        _vm.$set(_vm.driver, "lisenceNumber", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('field-messages', {
    staticClass: "form-control-feedback",
    attrs: {
      "name": "lisenceNumber",
      "show": "$touched || $submitted"
    }
  }, [_c('div', {
    attrs: {
      "slot": "required"
    },
    slot: "required"
  }, [_vm._v("License no is a required field")]), _vm._v(" "), _c('div', {
    attrs: {
      "slot": "pattern"
    },
    slot: "pattern"
  }, [_vm._v("License no is invalid")]), _vm._v(" "), _c('div', {
    attrs: {
      "slot": "minlength"
    },
    slot: "minlength"
  }, [_vm._v("Minimum length of license no is 10 character")])])], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "col-sm-3",
    attrs: {
      "id": "licenseExpiryDiv"
    }
  }, [_c('validate', {
    staticClass: "form-group required-field",
    attrs: {
      "auto-label": ""
    }
  }, [_c('label', {
    attrs: {
      "for": "dateAdded"
    }
  }, [_vm._v("License Expiry Date")]), _vm._v(" "), _c('date-picker', {
    attrs: {
      "required": "",
      "id": "licenseExpiryDate",
      "lang": "en",
      "name": "licenseExpiryDate",
      "width": "100%",
      "use-utc": "true",
      "format": "DD-MM-YYYY"
    },
    on: {
      "change": _vm.highlight
    },
    model: {
      value: (_vm.driver.licenseExpiryDate),
      callback: function($$v) {
        _vm.$set(_vm.driver, "licenseExpiryDate", $$v)
      },
      expression: "driver.licenseExpiryDate"
    }
  }), _vm._v(" "), _c('field-messages', {
    staticClass: "form-control-feedback",
    attrs: {
      "name": "licenseExpiryDate",
      "show": "$touched || $submitted"
    }
  }, [_c('div', {
    attrs: {
      "slot": "required"
    },
    slot: "required"
  }, [_vm._v("License Expiry Date is a required field")])])], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "col-sm-3"
  }, [_c('validate', {
    staticClass: "form-group required-field",
    class: _vm.fieldClassName(_vm.formstate.manager),
    attrs: {
      "auto-label": ""
    }
  }, [_c('label', [_vm._v("Journey Manager")]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.driver.manager),
      expression: "driver.manager"
    }],
    staticClass: "form-control",
    attrs: {
      "required": "",
      "name": "manager"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.driver, "manager", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, [_c('option', {
    attrs: {
      "value": "",
      "disabled": ""
    }
  }, [_vm._v("Select Journey Manager")]), _vm._v(" "), _vm._l((_vm.manager), function(item, index) {
    return _c('option', {
      key: index,
      domProps: {
        "value": item.key
      }
    }, [_vm._v("\n                                            " + _vm._s(item.value) + "\n                                        ")])
  })], 2), _vm._v(" "), _c('field-messages', {
    staticClass: "form-control-feedback",
    attrs: {
      "name": "manager",
      "show": "$touched || $submitted"
    }
  }, [_c('div', {
    attrs: {
      "slot": "required"
    },
    slot: "required"
  }, [_vm._v("Journey Manager is a required field")])])], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "col-sm-3"
  }, [_c('validate', {
    staticClass: "form-group required-field",
    class: _vm.fieldClassName(_vm.formstate.deviceId),
    attrs: {
      "auto-label": ""
    }
  }, [_c('label', [_vm._v("Device")]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.driver.deviceId),
      expression: "driver.deviceId"
    }],
    staticClass: "form-control",
    attrs: {
      "required": "",
      "name": "deviceId"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.driver, "deviceId", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, [_c('option', {
    attrs: {
      "value": "",
      "disabled": ""
    }
  }, [_vm._v("Select Device")]), _vm._v(" "), _vm._l((_vm.device_id), function(item, index) {
    return _c('option', {
      key: index,
      domProps: {
        "value": item.key
      }
    }, [_vm._v("\n                                            " + _vm._s(item.value) + "\n                                        ")])
  })], 2), _vm._v(" "), _c('field-messages', {
    staticClass: "form-control-feedback",
    attrs: {
      "name": "deviceId",
      "show": "$touched || $submitted"
    }
  }, [_c('div', {
    attrs: {
      "slot": "required"
    },
    slot: "required"
  }, [_vm._v("Device is a required field")])])], 1)], 1)]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-12"
  }, [_c('div', {
    staticClass: "col-sm-6"
  }, [_c('validate', {
    staticClass: "form-group required-field",
    class: _vm.fieldClassName(_vm.formstate.languageKnown),
    attrs: {
      "auto-label": ""
    }
  }, [_c('label', [_vm._v("Language Known")]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.driver.languageKnown),
      expression: "driver.languageKnown"
    }],
    staticClass: "form-control",
    attrs: {
      "required": "",
      "name": "languageKnown"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.driver, "languageKnown", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, [_c('option', {
    attrs: {
      "value": "",
      "disabled": ""
    }
  }, [_vm._v("Select Language")]), _vm._v(" "), _vm._l((_vm.language), function(item, index) {
    return _c('option', {
      key: index,
      domProps: {
        "value": item.key
      }
    }, [_vm._v("\n                                            " + _vm._s(item.value) + "\n                                        ")])
  })], 2), _vm._v(" "), _c('field-messages', {
    staticClass: "form-control-feedback",
    attrs: {
      "name": "languageKnown",
      "show": "$touched || $submitted"
    }
  }, [_c('div', {
    attrs: {
      "slot": "required"
    },
    slot: "required"
  }, [_vm._v("Language is a required field")])])], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "col-sm-6"
  }, [_c('validate', {
    staticClass: "form-group ",
    class: _vm.fieldClassName(_vm.formstate.defaultLanguage),
    attrs: {
      "auto-label": ""
    }
  }, [_c('label', [_vm._v("Default Language")]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.driver.defaultLanguage),
      expression: "driver.defaultLanguage"
    }],
    staticClass: "form-control",
    attrs: {
      "name": "defaultLanguage"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.driver, "defaultLanguage", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, [_c('option', {
    attrs: {
      "value": "",
      "disabled": ""
    }
  }, [_vm._v("Select Language")]), _vm._v(" "), _vm._l((_vm.language), function(item, index) {
    return _c('option', {
      key: index,
      domProps: {
        "value": item.key
      }
    }, [_vm._v("\n                                            " + _vm._s(item.value) + "\n                                        ")])
  })], 2)])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-12"
  }, [_c('div', {
    staticClass: "col-sm-6"
  }, [_c('validate', {
    staticClass: "form-group",
    class: _vm.fieldClassName(_vm.formstate.driverImage),
    attrs: {
      "auto-label": ""
    }
  }, [_c('label', [_vm._v("Driver Photo")]), _vm._v(" "), _c('input', {
    staticClass: "form-control",
    attrs: {
      "type": "file",
      "id": "fileinput",
      "required": ""
    },
    on: {
      "change": _vm.onFilechanged
    }
  }), _vm._v(" "), _c('field-messages', {
    staticClass: "form-control-feedback",
    attrs: {
      "name": "photo",
      "show": "$touched || $submitted"
    }
  }, [_c('div', {
    attrs: {
      "slot": "required"
    },
    slot: "required"
  }, [_vm._v("Please upload less than 3mb picture")])])], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "col-sm-6"
  }, [_c('validate', {
    staticClass: "form-group",
    class: _vm.fieldClassName(_vm.formstate.documents),
    attrs: {
      "auto-label": ""
    }
  }, [_c('label', [_vm._v("Other Document")]), _vm._v(" "), _c('input', {
    staticClass: "form-control",
    attrs: {
      "type": "file",
      "name": "otherInfo"
    },
    on: {
      "change": _vm.onDocumentchanged
    }
  }), _vm._v(" "), _c('field-messages', {
    staticClass: "form-control-feedback",
    attrs: {
      "name": "otherInfo",
      "show": "$touched || $submitted"
    }
  }, [_c('div', {
    attrs: {
      "slot": "required"
    },
    slot: "required"
  }, [_vm._v("Please upload less than 3mb document")])])], 1)], 1)]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-12"
  }, [_c('div', {
    staticClass: "col-sm-6"
  }, [_c('validate', {
    staticClass: "form-group",
    class: _vm.fieldClassName(_vm.formstate.addressDetails)
  }, [_c('label', [_vm._v("Address")]), _vm._v(" "), _c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model.lazy",
      value: (_vm.driver.addressDetails),
      expression: "driver.addressDetails",
      modifiers: {
        "lazy": true
      }
    }],
    staticClass: "form-control",
    attrs: {
      "name": "addressDetails",
      "placeholder": "Address"
    },
    domProps: {
      "value": (_vm.driver.addressDetails)
    },
    on: {
      "change": function($event) {
        _vm.$set(_vm.driver, "addressDetails", $event.target.value)
      }
    }
  })])], 1)])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-12 text-right"
  }, [_c('router-link', {
    attrs: {
      "to": {
        name: 'Driver'
      }
    }
  }, [_c('button', {
    staticClass: "mr-5 btn btn-default",
    attrs: {
      "type": "button"
    }
  }, [_vm._v("Cancel")])]), _vm._v(" "), _c('button', {
    staticClass: "mr-2 btn gradientbt",
    attrs: {
      "type": "submit",
      "disabled": !(_vm.formstate.$dirty && _vm.formstate.$valid)
    },
    on: {
      "click": _vm.createDriver
    }
  }, [_vm._v("Add Driver")])], 1)], 1)])])])])
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-11321448", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-11321448"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/views/driver/DriverCreate.vue
// module id = 2260
// module chunks = 0